export const ENDPOINTS = {
  getMeetingParticipants: (meetingId: string) => `/participants/${meetingId}`,
  getMeetingStatus: (meetingId: string) => `/status/${meetingId}`,
  apiDocs: '/docs/api',
  meetingBot: '/bot',
  organizationalAlerts: '/bot/alerted',
  user: '/user',
  reanalyze: (
    botId: string,
    participantId: string,
    reanalyzeVideo: boolean = false,
  ) =>
    `/bot/${botId}/participant/${participantId}/stream?audio=true&video=${reanalyzeVideo}`,
  userPreferences: '/user/preferences',
  userLogout: '/user/logout',
  authData: '/user/auth_data',
  companionTokenRefresh: '/user/token/refresh',
  companionAuthorize: '/auth/companion/authorize',
  companionLogout: '/auth/companion/logout',
  botReport: '/report/bot',
  msTeamsChatNotification: '/consent/chat',
  consent: '/consent',
  consentConfig: '/consent/config',
  consentCheck: '/consent/participant',
  consentRequired: '/consent/required',
  contactRequest: '/contact-request',
  msTeamsNotifyMeetingConsent: (tenantId: string) =>
    `/platforms/teams/tenants/${tenantId}/meetings/notify/consent`,
  msTeamsNotifyMeetingLocation: (tenantId: string) =>
    `/platforms/teams/tenants/${tenantId}/meetings/notify/location`,
  msTeamsJoinMeeting: (tenantId: string) =>
    `/platforms/teams/tenants/${tenantId}/meetings/join`,
  resolveParticipant: '/bot/participant/resolve',
  auditEvents: '/admin/audit/events',
  auditFilterOptions: '/admin/audit/filter-options',
  zoomOAuthAuthorize: '/zoom/oauth/pmm/authorize',
  zoomOAuthStatus: '/zoom/oauth/pmm',
  zoomOAuthDisconnect: '/zoom/oauth/pmm',
  zoomOAuthInClientAuthorize: '/zoom/oauth/pmm/in-client/authorize',
  zoomOAuthExchange: '/zoom/oauth/pmm/exchange',
};
